import { setStepUpPassword } from "@/api/stepUp";
import { useUserManager } from "@/tanstackQuery";
import { useMutation } from "@tanstack/react-query";

export const useSetStepUpPassword = () => {
  const userManager = useUserManager();

  return useMutation({
    mutationFn: setStepUpPassword,
    onSuccess: () => {
      userManager.patch({ hasStepUpPassword: true });
    },
  });
};
